import { API, graphqlOperation } from "aws-amplify";

import { listUserNotesQuery } from "./graphql/queries";

const listUserNotes = (userId) =>
  API.graphql(graphqlOperation(listUserNotesQuery, { userId }));

export default listUserNotes;
